import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-top footer text-light" }
const _hoisted_2 = { id: "footerInner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "footerSpace" }, " | ", -1)
const _hoisted_4 = { class: "footerLinks" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " Zimmer Biomet ", 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("a", {
          href: _ctx.about(),
          "data-testid": "linkAbout"
        }, _toDisplayString(_ctx.$t('about')), 9, _hoisted_5),
        _createTextVNode("  |  "),
        _createElementVNode("a", {
          href: _ctx.support(),
          "data-testid": "linkSupport"
        }, _toDisplayString(_ctx.$t('footer_default_support')), 9, _hoisted_6)
      ])
    ])
  ]))
}